var map = {
	"./DekoWallEspejo.png": 3551,
	"./DekoWallEspejoNegro.png": 8508,
	"./proyecto-web-fotos_circulo-solo-copy-2.png": 2549,
	"./proyecto-web-fotos_circulo-solo-copy-3.png": 6636,
	"./proyecto-web-fotos_circulo-solo-copy-4.png": 4035,
	"./proyecto-web-fotos_circulo-solo-copy-5.png": 2122,
	"./proyecto-web-fotos_circulo-solo-copy-6-1-300x300.png": 3428,
	"./proyecto-web-fotos_circulo-solo-copy.png": 6272,
	"./proyecto-web-fotos_circulo-solo.png": 5216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;